import { observer } from "mobx-react";
import React from "react";
import { ScrollView } from "react-native";
import { StepTopNav } from "~/components/V2/StepTopNav";
import { View } from "~/components/V2/View";
import { styleConstantsV2 } from "~/style/styleConstantsV2";
import type { PropsWithChildren } from "react";

export const BookAppointmentContainer = observer(
  function BookAppointmentContainer({
    children,
    title,
    shouldAnimateProgressBar = true,
  }: PropsWithChildren<{
    title: React.ReactNode;
    showHeader?: boolean;
    onBackPress?: () => void;
    shouldAnimateProgressBar?: boolean;
  }>) {
    return (
      <View flex>
        <StepTopNav
          shouldAnimateProgressBar={shouldAnimateProgressBar}
          title={title}
        />

        <ScrollView
          contentContainerStyle={{
            flexGrow: 1,
            backgroundColor: styleConstantsV2.colorWhite,
          }}
          style={{
            backgroundColor: styleConstantsV2.colorWhite,
          }}
        >
          {children}
        </ScrollView>
      </View>
    );
  },
);
